<template>
  <div>
    <a-modal
      :wrapClassName="'modal-sm'"
      centered
      title="Resumen de traspaso de póliza"
      v-model:visible="visibility"
    >
      <a-typography-paragraph>
        Revisa que los datos ingresados estén correctos.
      </a-typography-paragraph>
      <a-descriptions layout="horizontal" :column="1" bordered>
        <a-descriptions-item label="Inicio de vigencia">
          {{ values.requestStart.format('YYYY-MM-DD') }}
        </a-descriptions-item>
      </a-descriptions>

      <a-typography-title :level="5" class="mt-3">
        Datos póliza de origen
      </a-typography-title>
      <a-descriptions layout="horizontal" :column="1" bordered>
        <a-descriptions-item label="Nombre">
          {{ values.name }}
        </a-descriptions-item>
        <a-descriptions-item label="Rut">
          {{ values.rut }}
        </a-descriptions-item>
        <a-descriptions-item label="Empresa">
          {{ values.originCompany.businessName }}
        </a-descriptions-item>
        <a-descriptions-item label="Aseguradora">
          {{ values.originInsuranceCompany.businessName }}
        </a-descriptions-item>
        <a-descriptions-item label="Pólizas y grupos">
          <ul style="margin: 0; padding: 0 0 0 8px">
            <li v-for="policy in values.originPolicies" :key="policy.id">
              {{ policy.numberPolicy }}
              <ul style="margin: 0; padding: 0 0 0 16px">
                <li v-for="group in policy.originGroups" :key="group.id">
                  {{ group.name }}
                </li>
              </ul>
            </li>
          </ul>
        </a-descriptions-item>
      </a-descriptions>

      <a-typography-title :level="5" class="mt-3">
        Datos póliza de destino
      </a-typography-title>
      <a-descriptions layout="horizontal" :column="1" bordered>
        <a-descriptions-item label="Empresa">
          {{ values.destinyCompany.businessName }}
        </a-descriptions-item>
        <a-descriptions-item label="Aseguradora">
          {{ values.destinyInsuranceCompany.businessName }}
        </a-descriptions-item>
        <a-descriptions-item label="Pólizas, grupos y coberturas">
          <ul style="margin: 0; padding: 0 0 0 8px">
            <li v-for="policy in values.destinyPolicies" :key="policy.id">
              {{ policy.numberPolicy }}
              <ul style="margin: 0; padding: 0 0 0 16px">
                <li v-for="group in policy.destinyGroups" :key="group.id">
                  {{ group.name }}
                  <ul style="margin: 0; padding: 0 0 0 24px">
                    <li v-for="cgc in group.destinyCoverages" :key="cgc.id">
                      {{ cgc.coverage.name }}
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
          </ul>
        </a-descriptions-item>
        <a-descriptions-item
          label="Archivos opcionales"
          v-if="values.optionalFiles.length"
        >
          <ul style="margin: 0; padding: 0 0 0 8px">
            <li v-for="f in values.optionalFiles" :key="f.id">
              {{ f.name }}
            </li>
          </ul>
        </a-descriptions-item>
        <a-descriptions-item label="Mensaje">
          {{ values.message }}
        </a-descriptions-item>
      </a-descriptions>

      <template #footer>
        <a-button @click="closeModal" :disabled="props.loading">
          Cancelar
        </a-button>
        <a-button
          type="primary"
          @click="$emit('createTransfer')"
          :loading="props.loading"
        >
          Enviar
        </a-button>
      </template>
    </a-modal>
  </div>
</template>

<script setup>
import { ref, defineExpose, defineEmits, defineProps } from 'vue';

const props = defineProps({
  loading: {
    type: Boolean,
    default: false
  }
});

defineEmits(['createTransfer']);

const visibility = ref(false);
const values = ref({});

const openModal = (data) => {
  values.value = data;
  visibility.value = true;
};

const closeModal = () => {
  visibility.value = false;
};

defineExpose({ openModal, closeModal });
</script>
